module.exports = {
	array_chunk(array,size){
		const result = [];
		  for (let i = 0; i < array.length; i += size) {
		    result.push(array.slice(i, i + size));
		  }
		  return result;
	}
}


//////////////////
// WEBPACK FOOTER
// ./utils/utils.js
// module id = s/GO
// module chunks = 12